import { render, staticRenderFns } from "./ResizablePanel.vue?vue&type=template&id=13d5383c"
import script from "./ResizablePanel.vue?vue&type=script&lang=js"
export * from "./ResizablePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports